import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function BalloonDog({
  position = [55.47, -0.07, 9.64],
  rotation = [0, 0, 0],
  scale = 1,
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/Balloon_Dog.glb");
  const balloonScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    balloonScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [balloonScene]);

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={balloonScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/Balloon_Dog.glb");
